import { createContext } from "react";
import { CompanyBranch } from "../../types/branch";

export interface BranchContextType {
  currentBranch: CompanyBranch | null;
  availableBranches: CompanyBranch[];
  switchBranch: (branchId: number) => void;
  setBranchDirectly: (branch: CompanyBranch) => void;
  isLoading: boolean;
  isSwitching: boolean;
  error: Error | null;
}

export const BranchContext = createContext<BranchContextType | undefined>(undefined);
